import { useEffect } from 'react';

// Double-clicking an empty field that shows greyed example text copies that text into the field.
export default function PlaceholderDoubleClick() {
  useEffect(() => {
    const onDblClick = (e) => {
      const el = e.target;
      const isInput = el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement;
      if (!isInput || el.disabled || el.readOnly || el.value || !el.placeholder) return;
      if (el.type === 'password' || /^[•*\s]+$/.test(el.placeholder)) return;
      const proto = el instanceof HTMLTextAreaElement ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
      Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, el.placeholder);
      if (!el.value) return; // e.g. a number box whose example text is not a number
      el.dispatchEvent(new Event('input', { bubbles: true }));
      try { el.setSelectionRange(el.value.length, el.value.length); } catch { /* unsupported input type */ }
    };
    document.addEventListener('dblclick', onDblClick);
    return () => document.removeEventListener('dblclick', onDblClick);
  }, []);
  return null;
}
